import { jsxs, Fragment, jsx } from 'react/jsx-runtime';
import { TypographyContainer, P, A } from '@fabric-app/ui/components/Typography';
import { StoreNames, StoreToAppName, BriefStoreNames } from '../pricing.types.js';
import { useSubscriptionAccess, useQueryPricingManagementUrl } from '@fabric-app/compat/capabilities/pricing';
import { Button } from '@fabric-app/ui/components/Button';
import { LinkExternal } from '@fabric-app/ui/components/Link/LinkExternal';

const CanAlterSubscriptionReason = () => {
  const subscriptionAccess = useSubscriptionAccess();
  const { data: managementUrl } = useQueryPricingManagementUrl();
  if (subscriptionAccess.canAlterSubscription.allowed) return null;
  return /* @__PURE__ */ jsxs(Fragment, {
    children: [
      subscriptionAccess.canAlterSubscription.reason === "revenuecat_missing_entitlement" && /* @__PURE__ */ jsxs(TypographyContainer, {
        children: [
          /* @__PURE__ */ jsx(P, {
            children: "We noticed you have an active subscription, but it may be linked to a different account."
          }),
          /* @__PURE__ */ jsxs(P, {
            children: [
              "Are you signed in with the same ",
              StoreNames[subscriptionAccess.originalStore],
              " account that you used to purchase your subscription?"
            ]
          }),
          /* @__PURE__ */ jsxs(P, {
            children: [
              "Please check your device settings or contact",
              " ",
              /* @__PURE__ */ jsx(A, {
                href: "mailto:team@fabric.so",
                children: "team@fabric.so"
              }),
              " if you need help."
            ]
          })
        ]
      }),
      subscriptionAccess.canAlterSubscription.reason === "revenuecat_subscription_mismatch_woody" && /* @__PURE__ */ jsxs(TypographyContainer, {
        children: [
          /* @__PURE__ */ jsx(P, {
            children: "There seems to be a sync issue with your subscription status. Please try signing out and back in to refresh your subscription."
          }),
          /* @__PURE__ */ jsxs(P, {
            children: [
              "If the problem persists, contact our ",
              /* @__PURE__ */ jsx(A, {
                href: "mailto:team@fabric.so",
                children: "team@fabric.so"
              }),
              " ",
              "for assistance."
            ]
          })
        ]
      }),
      subscriptionAccess.canAlterSubscription.reason === "revenuecat_user_mismatch" && /* @__PURE__ */ jsxs(TypographyContainer, {
        children: [
          /* @__PURE__ */ jsx(P, {
            children: "We detected that your subscription may be linked to a different Fabric account."
          }),
          /* @__PURE__ */ jsx(P, {
            children: "Please make sure you‘re signed in with the account you originally used to subscribe."
          }),
          /* @__PURE__ */ jsx(P, {
            children: "If you have multiple Fabric accounts, you‘ll need to use the one associated with your subscription."
          })
        ]
      }),
      subscriptionAccess.canAlterSubscription.reason === "revenuecat_unavailable" && /* @__PURE__ */ jsxs(P, {
        children: [
          "There was an error while trying to connect to the",
          " ",
          StoreNames[subscriptionAccess.originalStore],
          " payment system. Please try again later."
        ]
      }),
      subscriptionAccess.canAlterSubscription.reason === "store_mismatch" && subscriptionAccess.originalStore === "promotional" && /* @__PURE__ */ jsx(P, {
        children: "You are subscribed to a promotional plan. Please contact support to manage your subscription."
      }),
      subscriptionAccess.canAlterSubscription.reason === "store_mismatch" && subscriptionAccess.originalStore !== "promotional" && /* @__PURE__ */ jsxs(TypographyContainer, {
        children: [
          /* @__PURE__ */ jsxs(P, {
            children: [
              "You purchased your subscription through",
              " ",
              StoreToAppName[subscriptionAccess.originalStore],
              "."
            ]
          }),
          /* @__PURE__ */ jsx(P, {
            children: "You‘ll need to manage or cancel it there."
          })
        ]
      }),
      subscriptionAccess.canAlterSubscription.reason === "lifetime" && /* @__PURE__ */ jsx(P, {
        children: "You are subscribed to a lifetime plan. You won‘t be able to change your subscription."
      }),
      managementUrl && subscriptionAccess.canManageSubscription.allowed && /* @__PURE__ */ jsxs(LinkExternal, {
        as: Button,
        href: managementUrl,
        shape: "full",
        children: [
          "View ",
          BriefStoreNames[subscriptionAccess.originalStore],
          " subscriptions"
        ]
      })
    ]
  });
};

export { CanAlterSubscriptionReason };
//# sourceMappingURL=CanAlterSubscriptionReason.js.map
